import React, { useState, useEffect } from "react";
import { getPublicTracking, getPublicByWaybillAndCourier } from "../../store/action/order";
import { normalizeTrackingStatus } from "../../services/helpers/status";
import { trackEvent, trackWithValue } from "../../services/analytics";
import { Helmet } from "react-helmet";
import LandingPageNav from "../../components/navbars/landingPage";
import FooterLandingPage from "../../components/footers/landing";
import Section from "../../components/landingPage/sections";
import { WaybillInput, SearchResult } from "./components";
import { autoDetectCourier } from "./helpers/courier";
import { getCouriers } from "../../store/action/courier";

const PublicTracking = (props) => {
  const [loading, setLoading] = useState(true);
  const [focus, setFocus] = useState("");
  const [waybillId, setWaybillId] = useState([""]);
  const [trackingLoading, setTrackingLoading] = useState(false);
  const [tracking, setTracking] = useState([]);
  const [courierList, setCourierList] = useState([]);
  const shortId = props.match.params.shortOrderId;

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    if (props.match.params.shortOrderId) {
      await getTrackingByShortId();
    }
    const { couriers } = await getCouriers();
    const filtered = [];

    for (let i = 0; i < couriers.length; i++) {
      if (i === 0) {
        filtered.push({
          courierCode: couriers[i].courierCode,
          courierName: couriers[i].courierName,
        });
      } else if (couriers[i].courierCode !== couriers[i - 1].courierCode)
        filtered.push({
          courierCode: couriers[i].courierCode,
          courierName: couriers[i].courierName,
        });
    }
    setCourierList(filtered);
    setLoading(false);
  };

  const getTrackingByShortId = async () => {
    try {
      const res = await getPublicTracking(props.match.params.shortOrderId);
      if (res.success) {
        const tk = res.tracking;
        const history = tk.history.reduce((r, i) => {
          r.push({
            eventDate: i.updated_at,
            note: normalizeTrackingStatus(i.note),
            status: i.status,
          });
          return r;
        }, []);
        setTracking(() => [{
          loading: false,
          shortId: true,
          orderId: tk.order_id,
          originName: tk.origin_name,
          destinationName: tk.destination_name,
          destinationAddress: tk.destination_address,
          courierCompany: tk.courier_code,
          courierService: tk.courier_service_code,
          waybillId: tk.waybill_id,
          status: tk.status,
          history: history,
        }]);
        setTrackingLoading(false);
      } else {
        alert(`Resi tidak dapat dilacak. Ada kemungkinan sudah expired atau belum terdaftar.`);
      }
    } catch (e) {
      console.log(e);
      alert("Gagal ambil data akun. Mohon ulangi kembali.");
    }
  };

  const trackingFormat = (waybillId, res) => {
    let newResult;
    if (res && res.success) {
      const tk = res;
      const history = tk.history.reduce((r, i) => {
        r.push({
          eventDate: i.updated_at,
          note: normalizeTrackingStatus(i.note),
          status: i.status,
        });
        return r;
      }, []);
      newResult = {
        orderId: tk.order_id,
        originName: tk.origin.contact_name,
        destinationName: tk.destination.contact_name,
        destinationAddress: tk.destination.address,
        courierCompany: tk.courier.company,
        waybillId: tk.waybill_id,
        status: tk.status,
        history: history,
      };
    } else {
      newResult = {
        orderId: "",
        originName: "",
        destinationName: "",
        destinationAddress: "",
        courierCompany: "",
        status: "",
        waybillId,
        history: [],
      };
    }

    return newResult;
  };

  const onSubmit = async () => {
    try {
      setTrackingLoading(true);
      trackWithValue("Check Courier Waybill", {
        action: "track",
        category: "Tools",
        label: "Track courier waybill from website",
        event: "Click",
        value: 200
      });

      for (let i = 0; i < waybillId.length; i++) {
        if (waybillId[i]) {
          const res = await getPublicByWaybillAndCourier(
            waybillId[i],
            autoDetectCourier(waybillId[i])
          );
          setTracking((oldValue) => [...oldValue, trackingFormat(waybillId[i], res)]);
        }
      }
      setTrackingLoading(false);
    } catch (e) {
      console.log(e);
      alert("Gagal ambil data akun. Mohon ulangi kembali.");
      setTrackingLoading(false);
    }
  };

  const reFetchData = async (courierCode, idx) => {
    try {
      const res = await getPublicByWaybillAndCourier(waybillId[idx], courierCode);

      if (!res.success) return true;

      const newTracking = [...tracking];
      newTracking[idx] = trackingFormat(waybillId[idx], res);
      setTracking(newTracking);
    } catch (e) {
      console.log(e);
      alert("Gagal ambil data akun. Mohon ulangi kembali.");
      setTrackingLoading(false);
    }
  };

  const onClickDownload = () => {
    trackEvent(`Click`, {
      action: "track",
      category: "Buttons",
      label: `Click Download Button on Public Tracking Page`,
      event: "Click",
    });
    window.open("https://bit.ly/BiteshipApp", "_blank");
  };

  const changeInputWaybill = (inputId, idx) => {
    const splittedInput = inputId.split("\n");
    const newWaybillIds = [...waybillId];
    const countNewArrayLength = newWaybillIds.length - 1 + splittedInput.length;
    const lengthDeficit = countNewArrayLength - 50;

    if (splittedInput.length > 1) {
      if (lengthDeficit > 0) {
        splittedInput.splice(splittedInput.length - lengthDeficit, lengthDeficit);
        alert("Jumlah no. resi yang dapat di input adalah 50.");
      }
      newWaybillIds.splice(idx, 1, ...splittedInput);
      setFocus(+idx + splittedInput.length - 1);
      setWaybillId(newWaybillIds);
    } else {
      newWaybillIds[idx] = inputId;
      setWaybillId(newWaybillIds);
    }
  };

  const deleteRowWaybill = (idx) => {
    const newWaybillIds = [...waybillId];
    if ((idx === 0 && newWaybillIds.length === 1) || idx === "all") {
      setWaybillId([""]);
    } else {
      newWaybillIds.splice(idx, 1);
      setWaybillId(newWaybillIds);
    }
    setFocus("");
  };

  return (
    <div className="bg-violet-900">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Cek Resi Semua Ekspedisi</title>
        
        <meta
          name="description"
          content="Biteship adalah platform untuk melakukan pemesanan dari berbagai macam kurir dibangun untuk para pemilik bisnis.
                Terdapat lebih dari 20 Kurir Indonesia yang bergabung menjadi partner pengiriman. Kami membantu optimasi pengiriman Anda secara end-to-end."
        />
        <link rel="canonical" href="https://biteship.com" />
      </Helmet>
      <LandingPageNav />

      <section className="slice">
        <div className="pt-5 container">
          <h1 className="text-black lh-150">
            <strong>Cek Resi Berbagai Ekspedisi</strong>
          </h1>
          <h2 className="text-violet-500 lh-150">
            <strong>Cek resi atau lacak pengiriman paket Anda.</strong>
          </h2>
          <p className="lead lh-180">
            Gunakan fasilitas cek resi Biteship secara gratis untuk keperluan bisinis Anda. Pilihan
            resi lengkap dari berbagai kurir atau ekspedisi di Indonesia.
          </p>
        </div>
      </section>

      {loading ? null : tracking.length < 1 ? (
        <WaybillInput
          onChangeInput={changeInputWaybill}
          waybillIds={waybillId}
          onSubmit={onSubmit}
          loading={trackingLoading}
          focus={focus}
          onDeleteRow={deleteRowWaybill}
        />
      ) : (
        <SearchResult
          tracking={tracking}
          loading={trackingLoading}
          onClickCourier={reFetchData}
          courierList={courierList}
          shortId={shortId}
        />
      )}

      <div className="bg-lighter py-5">
        <div className="text-center container ">
          <h2 className="text-lg text-muted">Cek Resi Ekspedisi</h2>
          <p className="text-light">
            Biteship cek resi kurir JNE, SiCepat, J&T (JNT), AnterAja, Shopee Express, Tiki dan banyak lainnya merupakan layanan pengiriman yang menyediakan aplikasi cek resi atau lacak
            paket pengiriman untuk bisnis Anda. Anda bisa cek resi JNE, cek resi TIKI, cek resi J&T,
            cek resi AnterAja dan cek resi kurir pengiriman lainnya. Cek resi pengiriman bisa
            dilakukan untuk berbagai kota tergantung pengiriman asal dan tujuan Anda. Semua kurir
            lengkap terdapat di Biteship sesuai kebutuhan bisnis Anda.
          </p>
        </div>

        <div>
          <div className="text-center container">
            <h2 className="text-lg text-muted">API Cek Resi atau API Lacak Pengiriman</h2>
            <p className="text-light">
              Biteship menyediakan API Cek Tracking atau API Cek Resi Pengiriman atau API Lacak
              Pengiriman ekspedisi untuk kebutuhan bisnis Anda. Anda bisa integrasikan website Anda
              untuk terhubung dengan API cek resi ekspedisi milik Bitehsip. Semua list layanan API
              JNE atau JNE API, API Gosend atau Gosend API, API AnterAja atau AnterAja API, API
              Deliveree atau Deliveree API, API Borzo, API Grab atau Grab API, API SiCepat atau
              SiCepat API, J&T API atau API J&T semua tersedia di Biteship.
            </p>
          </div>

          <div className="text-center container">
            <h2 className="text-lg text-muted">List Lengkap Cek Resi</h2>
            <p className="text-light">
              Biteship memiliki list layanan lengkap untuk Anda bisa cek resi atau resi pengiriman
              pengiriman atau lacak pengiriman ekspedisi. Anda bisa lacak pengiriman JNE atau cek
              resi JNE dan resi pengiriman JNE. Selain itu Anda juga bisa lacak pengiriman J&T atau
              cek resi J&T dan resi pengiriman J&T. Selain itu Anda juga bisa lacak pengiriman TIKI
              atau cek resi TIKI dan resi pengiriman TIKI. Selain itu Anda juga bisa lacak
              pengiriman AnterAja atau cek resi AnterAja dan resi pengiriman AnterAja. Selain itu
              Anda juga bisa lacak pengiriman RPX atau cek resi RPX dan resi pengiriman RPX. Selain
              itu Anda juga bisa lacak pengiriman SAP atau cek resi SAP dan resi pengiriman SAP.
              Selain itu Anda juga bisa lacak pengiriman SiCepat atau cek resi SiCepat dan resi
              pengiriman SiCepat. Selain itu Anda juga bisa lacak pengiriman POS Indonesia atau cek
              resi POS Indonesia dan resi pengiriman POS Indonesia. Selain itu Anda juga bisa lacak
              pengiriman Paxel atau cek resi Paxel dan resi pengiriman Paxel. Selain itu Anda juga
              bisa lacak pengiriman Gojek atau cek resi Gojek dan resi pengiriman Gojek. Selain itu
              Anda juga bisa lacak pengiriman GRAB atau cek resi GRAB dan resi pengiriman GRAB.
              Semua Tersedia via Biteship.
            </p>
          </div>
        </div>

        <div style={{ height: 320 }} />
      </div>

      <Section />
      <FooterLandingPage />
    </div>
  );
};

export default PublicTracking;
